<div class="context-menu">
  <p class="lead p-2 ps-3 m-0 text-center border-bottom">Product Bin</p>

  <button [disabled]="!canEdit" (click)="removeSingle.emit('removeSingle')">
    Remove this product from layout
  </button>
  <button [disabled]="!canEdit" (click)="removeFiltered.emit('removeFiltered')">
    Remove all filtered products from layout
  </button>
</div>
